import React from 'react';
import styles from './DestructiveToggle.module.scss';

interface Props {
  value: boolean;
  onChange: (v: boolean) => void;
}

export const DestructiveToggle: React.FC<Props> = ({ value, onChange }) => (
  <div className={styles.wrapper}>
    <label className={styles.toggle}>
      <input type="checkbox" checked={value} onChange={(e) => onChange(e.target.checked)} />
      <span className={styles.slider} />
      <span className={styles.label}>Allow destructive tools</span>
    </label>
    {value && (
      <div className={styles.warning}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M12 9v4m0 4h.01M4.93 19h14.14c1.34 0 2.18-1.45 1.51-2.61L13.51 4.34a1.73 1.73 0 00-3.02 0L3.42 16.39C2.75 17.55 3.59 19 4.93 19z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <span>
          Destructive tools (replace_asset, tag_assets_bulk, delete_share, etc.) will run unattended.
          Only enable this if you trust the prompt to not cause data loss.
        </span>
      </div>
    )}
  </div>
);
